import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOOptimizations = ({ 
  title,
  description,
  canonical,
  hrefLang,
  imageUrl,
  imageAlt,
  publishedTime,
  modifiedTime,
  section,
  tags = [],
  noIndex = false
}) => {
  return (
    <Helmet>
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Language alternates */}
      {hrefLang && Object.entries(hrefLang).map(([lang, url]) => (
        <link key={lang} rel="alternate" hrefLang={lang} href={url} />
      ))}
      
      {/* Article specific Open Graph */}
      {publishedTime && (
        <>
          <meta property="article:published_time" content={publishedTime} />
          <meta property="article:author" content="Saket Bundele" />
          <meta property="article:author" content="Pallavi Korade" />
          <meta property="article:publisher" content="https://www.facebook.com/safarnamah" />
        </>
      )}
      
      {modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}
      
      {section && (
        <meta property="article:section" content={section} />
      )}
      
      {tags.length > 0 && tags.map((tag, index) => (
        <meta key={index} property="article:tag" content={tag} />
      ))}
      
      {/* Enhanced image metadata */}
      {imageUrl && (
        <>
          <meta property="og:image:secure_url" content={imageUrl} />
          <meta property="og:image:type" content="image/jpeg" />
          <meta name="twitter:image:src" content={imageUrl} />
        </>
      )}
      
      {imageAlt && (
        <>
          <meta property="og:image:alt" content={imageAlt} />
          <meta name="twitter:image:alt" content={imageAlt} />
        </>
      )}
      
      {/* Search engine directives */}
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <>
          <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
          <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        </>
      )}
      
      {/* Additional SEO meta tags */}
      <meta name="format-detection" content="telephone=no" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      
      {/* Performance hints */}
      <link rel="preconnect" href="https://images.unsplash.com" crossOrigin="anonymous" />
      <link rel="dns-prefetch" href="https://images.unsplash.com" />
    </Helmet>
  );
};

export default SEOOptimizations;